import { CountriesState } from '../../models/countries-state';

export const initialCountriesState: CountriesState = {
	countries: [],
	paymentMethods: [],
	allPaymentMethod: [],
	myCountry: { name: '', code: '', currencyCode: '' },
};
